import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';

import { fetchVendorLogIndex } from '../../api/vendor-work-orders.js';

export function VendorLogsIndexPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['vendor', 'logs-index'],
    queryFn: fetchVendorLogIndex,
  });

  if (isLoading) return <p className="text-sm text-muted">Loading…</p>;

  if (!data || data.items.length === 0) {
    return <p className="text-sm text-muted">No per-unit logs assigned to your company.</p>;
  }

  return (
    <div className="space-y-3">
      <h1 className="text-lg font-semibold text-fg">Per-unit logs</h1>
      <ul className="space-y-2">
        {data.items.map((item) => (
          <li key={item.workOrderId}>
            <Link
              to={`/vendor/work/${item.workOrderId}/units`}
              className="block rounded-lg border border-border bg-surface p-4 active:bg-surface-muted"
            >
              <p className="text-base font-semibold text-fg">{item.building.name}</p>
              <p className="text-sm text-fg">{item.title}</p>
              <p className="mt-1 text-xs text-muted">
                {item.displayNumber} · {item.progress.signedOff} of {item.progress.total} units
                signed off
              </p>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
